// test2589
(2589 && 0);
